export const PENDING = 'PENDING';
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const RESET = 'RESET';
export const SET = 'SET';
export const UNSET = 'UNSET';

export const createRequestTypes = (base) =>
  [RESET, REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});

export const createFlagTypes = (base) =>
  [SET, UNSET, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});

export const SELECTED_VEHICLE_TYPE = createFlagTypes('SELECTED_VEHICLE_TYPE');
export const PARKING_LOCATION = createFlagTypes('PARKING_LOCATION');
export const AVAILABLE_PARKING_SITES = createFlagTypes(
  'AVAILABLE_PARKING_SITES'
);
export const SHOW_PARKING_DETAIL_CARD = createFlagTypes(
  'SHOW_PARKING_DETAIL_CARD'
);

export const SHOW_MY_BOOKING_MODAL = createFlagTypes('SHOW_MY_BOOKING_MODAL');
